import { LRLanguage, LanguageSupport, LanguageDescription } from '@codemirror/language';
import { parseMixed } from '@lezer/common';
import { ExternalTokenizer, LRParser, ContextTracker } from '@lezer/lr';
import { Tag, tags, styleTags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const preDiagramLine = 7,
  PieDiagram = 1,
  MindmapDiagram = 2,
  FlowchartDiagram = 3;

const skipCodePoints$1 = [-1, 9, 13, 32];
const diagramMap = {
    mindmap: MindmapDiagram,
    pie: PieDiagram,
    flowchart: FlowchartDiagram,
    graph: FlowchartDiagram,
};
const diagrams = Object.keys(diagramMap);
const diagramText = new ExternalTokenizer((input) => {
    if (skipCodePoints$1.includes(input.next))
        return;
    let tokens = '';
    while (input.next != 10 && input.next !== -1) {
        tokens += String.fromCodePoint(input.next);
        input.advance();
    }
    input.advance();
    const activeDiagram = diagrams.filter((diagram) => {
        return tokens.startsWith(diagram);
    });
    if (activeDiagram.length > 0) {
        while (input.next !== -1) {
            input.advance();
        }
        input.acceptToken(diagramMap[activeDiagram[0]]);
    }
    else {
        input.acceptToken(preDiagramLine);
    }
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const parser$3 = LRParser.deserialize({
  version: 14,
  states: "nOVQROOOOQQ'#Ca'#CaOVQROOQOQPOOOOQQ-E6_-E6_",
  stateData: "e~OXOS~OPROQRORROVPO~O",
  goto: "]UPPPPPVQQORSQ",
  nodeNames: "⚠ PieDiagram MindmapDiagram FlowchartDiagram MermaidDiagram",
  maxTerm: 9,
  skippedNodes: [0],
  repeatNodeCount: 1,
  tokenData: "j~RRXY[]^[pq[~aRX~XY[]^[pq[",
  tokenizers: [0, diagramText],
  topRules: {"MermaidDiagram":[0,4]},
  tokenPrec: 0
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const indent = 30,
  LineText1 = 1,
  LineText2 = 2,
  LineText3 = 3,
  LineText4 = 4,
  LineText5 = 5,
  newline$2 = 31,
  newlineEmpty = 32;

const LineTextTokens = [LineText1, LineText2, LineText3, LineText4, LineText5];
const newline$1 = 10, carriageReturn = 13, space = 32, tab = 9, hash = 35, colon = 58, parenL = 40, parenR = 41, bracketL = 91, bracketR = 93, braceL = 123, braceR = 125;
const newlines = new ExternalTokenizer((input, _stack) => {
    if (input.next < 0)
        return;
    else {
        input.advance();
        let spaces = 0;
        while (input.next == space || input.next == tab) {
            input.advance();
            spaces++;
        }
        let empty = input.next == newline$1 ||
            input.next == carriageReturn ||
            input.next == hash;
        input.acceptToken(empty ? newlineEmpty : newline$2, -spaces);
    }
}, { contextual: true, fallback: true });
const lineTextType = new ExternalTokenizer((input, stack) => {
    let chars = 0;
    while (input.next > -1 && input.next !== newline$1) {
        if (input.next === colon)
            return;
        if (input.next === parenL ||
            input.next === bracketL ||
            input.next === braceL) {
            if (chars > 0) {
                input.acceptToken(stack.context.lineType);
                return;
            }
            else
                return;
        }
        if ((input.next === parenR ||
            input.next === bracketR ||
            input.next === braceR) &&
            chars > 0) {
            input.acceptToken(stack.context.lineType);
            return;
        }
        input.advance();
        chars++;
    }
    input.acceptToken(stack.context.lineType);
});
const indentation = new ExternalTokenizer((input, _stack) => {
    let prev = input.peek(-1);
    if (prev == newline$1 || prev == carriageReturn) {
        while (true) {
            if (input.next == space)
                ;
            else if (input.next == tab)
                ;
            else
                break;
            input.advance();
        }
        if (input.next != newline$1 &&
            input.next != carriageReturn &&
            input.next != hash) {
            input.acceptToken(indent);
        }
    }
});
const indentTracker = {
    lineType: LineText1,
};
const countIndent = (space) => {
    let depth = 0;
    for (let i = 0; i < space.length; i++)
        depth += space.charCodeAt(i) == tab ? 8 - (depth % 8) : 1;
    return depth;
};
const getLineType = (depth) => {
    return LineTextTokens[depth % 5];
};
const trackIndent = new ContextTracker({
    start: indentTracker,
    shift(context, term, stack, input) {
        if (term === indent) {
            const depth = countIndent(input.read(input.pos, stack.pos));
            context.lineType = getLineType(depth);
        }
        return context;
    },
});

const mermaidTags = {
    diagramName: Tag.define(tags.typeName),
};
const mindmapTags = {
    diagramName: Tag.define(mermaidTags.diagramName),
    lineText1: Tag.define(),
    lineText2: Tag.define(),
    lineText3: Tag.define(),
    lineText4: Tag.define(),
    lineText5: Tag.define(),
};
const pieTags = {
    diagramName: Tag.define(mermaidTags.diagramName),
    lineComment: Tag.define(tags.lineComment),
    number: Tag.define(tags.number),
    showData: Tag.define(tags.keyword),
    string: Tag.define(tags.string),
    title: Tag.define(tags.keyword),
    titleText: Tag.define(tags.string),
};
const flowchartTags = {
    diagramName: Tag.define(mermaidTags.diagramName),
    keyword: Tag.define(tags.keyword),
    lineComment: Tag.define(tags.lineComment),
    link: Tag.define(tags.contentSeparator),
    nodeEdge: Tag.define(tags.contentSeparator),
    nodeEdgeText: Tag.define(tags.string),
    nodeId: Tag.define(tags.variableName),
    nodeText: Tag.define(tags.string),
    number: Tag.define(tags.number),
    orientation: Tag.define(tags.modifier),
    string: Tag.define(tags.string),
};

const mindmapHighlighting = styleTags({
    DiagramName: mindmapTags.diagramName,
    LineText1: mindmapTags.lineText1,
    LineText2: mindmapTags.lineText2,
    LineText3: mindmapTags.lineText3,
    LineText4: mindmapTags.lineText4,
    LineText5: mindmapTags.lineText5,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_word$1 = {__proto__:null,mindmap:72, icon:76};
const parser$2 = LRParser.deserialize({
  version: 14,
  states: "&fOYQ[OOOOQW'#Cw'#CwQbQ[OOQgQ[OOOOQW'#Cc'#CcOOQW-E6u-E6uOlQ]O'#CdOOQW'#Cx'#CxQgQ[OOO!]Q^O,59OOOQW-E6v-E6vOOQW'#DR'#DRO!vQ[O'#CgO!{Q^O'#CjO!{Q^O'#CmO!{Q^O'#CnO!{Q^O'#CqO!{Q^O'#CrO!{Q^O'#CsO!{Q^O'#CvOOQW'#DU'#DUO#^Q[O1G.jOOQW1G.j1G.jO#hQ[O,59ROOQW'#Ch'#ChOOQW,59U,59UO#mQ[O,59XO#rQ[O,59YO#wQ[O,59]O#|Q[O,59^O$RQ[O,59_O$WQ[O,59bOOQW7+$U7+$UO!{Q^O1G.mOOQW1G.s1G.sOOQW1G.t1G.tOOQW1G.w1G.wOOQW1G.x1G.xOOQW1G.y1G.yOOQW1G.|1G.|O$]Q[O7+$XOOQW<<Gs<<Gs",
  stateData: "$b~OrOSpOS~OoPOtSO~OoPO~OoUO~OnXOmWXoWX~OXbO]_O`^OcaOd`OicO~OPZOQZORZOSZOTZOY[Ow]O~PwOvhO~OPZOQZORZOSZOTZO~OmWioWi~PwO]qO~O_rO~OXsO~OctO~OduO~O]vO~OhwO~OXyO~O",
  goto: "#[yPPPPPPPz}PP!R!UP!RPP!X!XPP!X!X!XPP!X!]!cPPPPPPPP!iPP#URROTVRWRfXRg[TdXeQQORTQQWRRYWQeXQi]Qj^Qk_Ql`QmaQnbQocRxqQfXRpe",
  nodeNames: "⚠ LineText1 LineText2 LineText3 LineText4 LineText5 MindmapDiagram DiagramName Line ) :: IconLine Icon ( ClassLine ] [ Square RoundedSquare )) (( Circle Bang Cloud }} {{ Hexagon",
  maxTerm: 40,
  context: trackIndent,
  nodeProps: [
    ["openedBy", 9,"(",15,"[",19,"((",24,"{{"],
    ["closedBy", 13,")",16,"]",20,"))",25,"}}"]
  ],
  propSources: [mindmapHighlighting],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "$b~R]XYz[]zpqzxy!fyz!s![!]#Q!c!}#e!}#O#p#O#P!]#P#Q#u#T#o#e#o#p#z#q#r$V~!PSr~XYz[]zpqz#O#P!]~!`QYZz]^z~!kP]~xy!n~!sOd~~!xPX~yz!{~#QOc~~#TP![!]#W~#]PY~![!]#`~#eOw~~#jQs~!c!}#e#T#o#e~#uO`~~#zO_~~#}P#o#p$Q~$VOi~~$YP#q#r$]~$bOh~",
  tokenizers: [indentation, lineTextType, 0, newlines],
  topRules: {"MindmapDiagram":[0,6]},
  specialized: [{term: 35, get: value => spec_word$1[value] || -1}],
  tokenPrec: 0
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const TitleText = 1;

const newline = 10;
const titleText = new ExternalTokenizer((input) => {
    let { next } = input;
    if (next === newline) {
        input.acceptToken(TitleText);
        return;
    }
    while (input.next !== newline && input.next !== -1) {
        input.advance();
    }
    input.acceptToken(TitleText);
});

const pieHighlighting = styleTags({
    DiagramName: pieTags.diagramName,
    LineComment: pieTags.lineComment,
    Number: pieTags.number,
    ShowData: pieTags.showData,
    String: pieTags.string,
    Title: pieTags.title,
    TitleText: pieTags.titleText,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_word = {__proto__:null,pie:36, showData:38, title:40};
const parser$1 = LRParser.deserialize({
  version: 14,
  states: "#xO]QQOOObQQO'#ClOOQO'#Cf'#CfQ]QQOOOOQO'#C`'#C`OsQQO'#CcOOQO'#Cg'#CgOxQQO,59WO!TQQO,59WO!cQRO,59WOOQO'#Ca'#CaOOQP'#Cb'#CbOOQO-E6d-E6dO!qQQO,58}OOQO-E6e-E6eO!vQQO1G.rO#RQRO1G.rO!vQQO1G.rOOQO1G.i1G.iO#^QQO7+$^O#^QQO7+$^O#iQQO<<Gx",
  stateData: "#t~O^OSQOS_OS~ObSO~OWTOcYOdZO[`Xb`X~Oe]O~OWTO[`ab`a~OWTOdZO[`ab`a~OPaOWTO[`ab`a~OXbO~OWTO[`ib`i~OPcO[`ib`i~OWTO[`qb`q~OWTO[`yb`y~O",
  goto: "!iaPPPPbfioPPz!QPPPP!eTPORRWPQXPR`WcUPVWX_acdeQROR[RQVPW^V_deS_WXQdaRecTQOR",
  nodeNames: "⚠ TitleText LineComment PieDiagram DiagramName ShowData Title Dataset String Number",
  maxTerm: 21,
  propSources: [pieHighlighting],
  skippedNodes: [0,2],
  repeatNodeCount: 2,
  tokenData: "%[~RYXYqYZ!P]^qpqqrs!Uuv#r!Q![$a![!]$z!c!}%P#T#o%P~vR^~XYq]^qpqq~!UO_~~!XVOr!Urs!ns#O!U#O#P!s#P;'S!U;'S;=`#l<%lO!U~!sOW~~!vRO;'S!U;'S;=`#P;=`O!U~#SWOr!Urs!ns#O!U#O#P!s#P;'S!U;'S;=`#l;=`<%l!U<%lO!U~#oP;=`<%l!U~#uPuv#x~#}SQ~OY#xZ;'S#x;'S;=`$Z<%lO#x~$^P;=`<%l#x~$fQX~!O!P$l!Q![$a~$oP!Q![$r~$wPX~!Q![$r~%POe~~%UQa~!c!}%P#T#o%P",
  tokenizers: [titleText, 0],
  topRules: {"PieDiagram":[0,3]},
  specialized: [{term: 17, get: value => spec_word[value] || -1}],
  tokenPrec: 0
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const NodeEdgeText = 1,
  NodeText = 2;

const skipCodePoints = [-1, 9, 13, 32, 34, 39, 96];
const startBracketCodePoints = [40, 62, 91, 123, 124];
const endBracketCodePoints = [41, 93, 124, 125];
const hyphen = 45;
const equal = 61;
const dot = 46;
const nodeText = new ExternalTokenizer((input) => {
    if (skipCodePoints.includes(input.next) ||
        startBracketCodePoints.includes(input.next))
        return;
    while (!endBracketCodePoints.includes(input.next) && input.next !== -1) {
        input.advance();
    }
    input.acceptToken(NodeText);
});
const nodeEdgeText = new ExternalTokenizer((input) => {
    if (skipCodePoints.includes(input.next) ||
        startBracketCodePoints.includes(input.next) ||
        input.next === hyphen ||
        input.next === equal ||
        input.next === dot)
        return;
    while (input.next !== hyphen &&
        input.next !== equal &&
        input.next !== dot &&
        input.next !== -1) {
        input.advance();
    }
    input.acceptToken(NodeEdgeText);
});

const flowchartHighlighting = styleTags({
    '( )': tags.paren,
    '[ ]': tags.squareBracket,
    '{ }': tags.brace,
    '<': tags.angleBracket,
    DiagramName: flowchartTags.diagramName,
    DoubleEqual: flowchartTags.link,
    DoubleHyphen: flowchartTags.link,
    Keyword: flowchartTags.keyword,
    LineComment: flowchartTags.lineComment,
    Link: flowchartTags.link,
    NodeEdge: flowchartTags.nodeEdge,
    NodeEdgeText: flowchartTags.nodeEdgeText,
    NodeId: flowchartTags.nodeId,
    NodeText: flowchartTags.nodeText,
    Number: flowchartTags.number,
    Orientation: flowchartTags.orientation,
    String: flowchartTags.string,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_identifier = {__proto__:null,flowchart:74, graph:76, TB:80, TD:82, BT:84, RL:86, LR:88, subgraph:210, end:212, direction:214, click:216, call:218, href:220, style:222, class:224, classDef:226, linkStyle:228, _self:230, _blank:232, _parent:234, _top:236};
const parser = LRParser.deserialize({
  version: 14,
  states: "1vOVQSOOOsQSO'#DPOOQO'#Cr'#CrQVQSOOOOQO'#C`'#C`OOQO'#Cs'#CsO!QQSO,59kO!_QSO,59kOOQO'#Ca'#CaOOQO-E6p-E6pOOQO-E6q-E6qO&bQSO1G/VO&bQSO1G/VO*eQSO'#CcOOQO'#Cc'#CcO.{OWO'#CfO/TO`O'#CfO/]OpO'#CfO/eQUO'#DcO/yQUO'#DsO0_QUO'#DoO0mQUO'#DqO0_QUO'#DuOOQO'#Cd'#CdOOQO'#Cm'#CmO5cQSO'#CmO5sQSO'#CmO6TQSO'#CmO6TQSO'#CmO6]QTO'#CmO6tQTO'#CoOOQO'#Ct'#CtO;WQSO'#DZOOQO'#DZ'#DZO;kQSO1G/VOOQO'#Cn'#CnO;yQSO7+$qO<^QSO7+$qO<lQSO,59[OOOO'#Cu'#CuO<qOWO,59QOOQO,59Q,59QOOOO'#Cv'#CvO<yO`O,59QOOOO'#Cw'#CwO=ROpO,59QOOQO'#Dd'#DdO=ZQSO,59}O0_QUO,5:VO=`QUO,5:YO0_QUO,5:WO0_QUO,5:XO=qQSO,5:_O=vQSO,5:ZO={QSO,5:]O0_QUO,5:^O>QQSO,5:aOOQO'#Cx'#CxOBsQSO,59XOOQO'#D{'#D{OOQO,59X,59XOOQO'#Cy'#CyOBzQSO,59XOOQO'#ET'#ETOOQO'#Cz'#CzOC[QSO,59XO>VQSO,59XOCdQSO,59XOCqQSO,59XOC|QSO,59XOOQO'#Ex'#ExODWQSO,59ZOE|QSO,59ZOOQO-E6r-E6rOOQO,59u,59uOFTQSO'#C{O<^QSO7+$qOF_QSO<<H]OF_QSO<<H]OOQO1G.v1G.vOOOO-E6s-E6sOOQO1G.l1G.lOOOO-E6t-E6tOOOO-E6u-E6uOOQO1G/i1G/iOFmQSO1G/qOFrQSO1G/tO0_QUO1G/zOFwQSO1G/rOF|QSO1G/sOOQO1G/y1G/yOOQO1G/u1G/uOOQO1G/w1G/wOGRQSO1G/xOOQO1G/{1G/{OOQO-E6v-E6vOOQO1G.s1G.sOOQO-E6w-E6wOOQO-E6x-E6xOKkQSO1G.sOKxQSO1G.sOLSQSO1G.uOL_QSO1G.uOOQO1G.u1G.uO6iQSO'#CmOOQO,59g,59gO!!xQSO<<H]OOQO-E6y-E6yO!#]QSOAN=wO!#kQSOAN=wO!$OQSO7+%]O!$TQSO7+%`O!$YQSO7+%fO!$_QSO7+%^O!$dQSO7+%_O!$iQSO7+%dOOQO7+$_7+$_O!$nQSO7+$aOOQO7+$a7+$aO!)XQSOG23cOOQO<<Hw<<HwOOQO<<Hz<<HzO!)lQSO<<IQOOQO<<Hx<<HxOOQO<<Hy<<HyOOQO<<IO<<IOOOQO<<G{<<G{O!)qQSOAN>lOOQOG24WG24W",
  stateData: "!*U~OrOS~OuSOvSO~OwTOxWOyWOzWO{WO|WO~OpsXusXvsX~P_Opsausavsa~P_OUqOXbO[cO^eO`fOeoOt]O!OoO!PoO!QoO!RoO!SoO!T^O!U^O!X_O!Z`O!]aO!ddO!jhO!khO!lhO!miO!shO!thO!ujO!yhO!zhO!{hO!|hO!}hO#OhO#PhO#QiO#RjO#SkO#UiO#VjO#WkO#XiO#YjO#ZlO#[mO#]sO#^sO#_sO#`sO#asO#bsO#csO#dsO#esO#fsO#gsO#hsO#isO#jsO#knO#mnOpsausavsa~P_OUqOXbO[cO^eO`fOeoOt]O!OoO!PoO!QoO!RoO!SoO!T^O!U^O!X_O!Z`O!]aO!ddO!jhO!khO!lhO!miO!shO!thO!ujO!yhO!zhO!{hO!|hO!}hO#OhO#PhO#QiO#RjO#SkO#UiO#VjO#WkO#XiO#YjO#ZlO#[mO#]sO#^sO#_sO#`sO#asO#bsO#csO#dsO#esO#fsO#gsO#hsO#isO#jsO#knO#mnOpsiusivsi~P_O!nvOXVX[VX^VX`VXeVXpVXtVXuVXvVXwVXxVXyVXzVX{VX|VX!OVX!PVX!QVX!RVX!SVX!TVX!UVX!XVX!ZVX!]VX!dVX!jVX!kVX!lVX!mVX!sVX!tVX!uVX!yVX!zVX!{VX!|VX!}VX#OVX#PVX#QVX#RVX#SVX#UVX#VVX#WVX#XVX#YVX#ZVX#[VX#]VX#^VX#_VX#`VX#aVX#bVX#cVX#dVX#eVX#fVX#gVX#hVX#iVX#jVX#kVX#mVX#nVX~O!XyO!YwO~O!ZyO![zO~O!]yO!^|O~OQ!OOX!RO[!QO!X_O!Z`O!]aO~OQ!OOX!TO[!SO!X_O!Z`O!]aO~OQ!OO!X_O!Z`O!]aO~OQ!OO^!XO!X_O!Z`O!]aO~OXaX[aX^aX`aXeaXpaXtaXuaXvaXwaXxaXyaXzaX{aX|aX!OaX!PaX!QaX!RaX!SaX!TaX!UaX!XaX!ZaX!]aX!daX!jaX!kaX!laX!maX!saX!taX!uaX!yaX!zaX!{aX!|aX!}aX#OaX#PaX#QaX#RaX#SaX#UaX#VaX#WaX#XaX#YaX#ZaX#[aX#]aX#^aX#_aX#`aX#aaX#baX#caX#daX#eaX#faX#gaX#haX#iaX#jaX#kaX#maX#naX~O!n!ZO!p!]O!q!]O!r!]O~P1OO!p!aO!q!aO!v!_O!x!aO~P1OO!n!dO#T!bO~OP!hO!X_O!Z`O!]aO!n!gO!r!^O#T!bO~OP!hO!X_O!Z`O!]aO~OXbO[cO^eO`fOeoOt]OxWOyWOzWO{WO|WO!OoO!PoO!QoO!RoO!SoO!T^O!U^O!X_O!Z`O!]aO!ddO!jhO!khO!lhO!miO!shO!thO!ujO!yhO!zhO!{hO!|hO!}hO#OhO#PhO#QiO#RjO#SkO#UiO#VjO#WkO#XiO#YjO#ZlO#[mO#]sO#^sO#_sO#`sO#asO#bsO#csO#dsO#esO#fsO#gsO#hsO#isO#jsO#knO#mnO~O#n!lOp}Xu}Xv}Xw}X~P7SOwTOpsiusivsi~OUqOwTOpsqusqvsq~P7SOwTOpsqusqvsq~Ot!qO~O!X!sO!YwO~O!Z!sO![zO~O!]!sO!^|O~OZ!vO~OQ!OOX!yO!X_O!Z`O!]aO~O]!|O~O]!}O~O_#OO~O`#QO~O!p!]O!q!]O!r!]OXaa[aa^aa`aaeaapaataauaavaawaaxaayaazaa{aa|aa!Oaa!Paa!Qaa!Raa!Saa!Taa!Uaa!Xaa!Zaa!]aa!daa!jaa!kaa!laa!maa!saa!taa!uaa!yaa!zaa!{aa!|aa!}aa#Oaa#Paa#Qaa#Raa#Saa#Uaa#Vaa#Waa#Xaa#Yaa#Zaa#[aa#]aa#^aa#_aa#`aa#aaa#baa#caa#daa#eaa#faa#gaa#haa#iaa#jaa#kaa#maa#naa~O!n!ZO~P>VO!p!aO!q!aO!v!_O!x!aO~P>`O!n#VO#T!bO~O!n#VO!r#SO#T!bO~P>`O!n#WO!r#SO#T!bO~O!p#SO!q#SO~P>`O!n#YO!r#ZO#T!bO~O!jhO!khO!lhO!miO!shO!thO!ujO!yhO!zhO!{hO!|hO!}hO#OhO#PhO#QiO#RjO#SkO#UiO#VjO#WkO#XiO#YjO#ZlO~O#[#[O~PDcOUqOwTO~P7SOwTOpsyusyvsy~O]#bO~OZ#cO~O]#eO~OZ#fO~O_#gO~OXai[ai^ai`aieaipaitaiuaivaiwaixaiyaizai{ai|ai!Oai!Pai!Qai!Rai!Sai!Tai!Uai!Xai!Zai!]ai!dai!jai!kai!lai!mai!sai!tai!uai!yai!zai!{ai!|ai!}ai#Oai#Pai#Qai#Rai#Sai#Uai#Vai#Wai#Xai#Yai#Zai#[ai#]ai#^ai#_ai#`ai#aai#bai#cai#dai#eai#fai#gai#hai#iai#jai#kai#mai#nai~O!p!]O!q!]O!r!]O~PGWO!p#hO!q#hO~PGWO!n#iO!r#jO#T!bO~O!p#jO!q#jOXci[ci^ci`ciecipcitciucivciwcixciycizci{ci|ci!Oci!Pci!Qci!Rci!Sci!Tci!Uci!Xci!Zci!]ci!dci!jci!kci!lci!mci!sci!tci!uci!yci!zci!{ci!|ci!}ci#Oci#Pci#Qci#Rci#Sci#Uci#Vci#Wci#Xci#Yci#Zci#[ci#]ci#^ci#_ci#`ci#aci#bci#cci#dci#eci#fci#gci#hci#ici#jci#kci#mci#nci~OUqOwTOpsyusyvsy~P7SOwTOps!Rus!Rvs!R~OUqOwTOps!Rus!Rvs!R~P7SOZ#lO~OZ#mO~OZ#nO~O]#oO~O]#pO~O_#qO~O!p#rO!q#rOXcq[cq^cq`cqecqpcqtcqucqvcqwcqxcqycqzcq{cq|cq!Ocq!Pcq!Qcq!Rcq!Scq!Tcq!Ucq!Xcq!Zcq!]cq!dcq!jcq!kcq!lcq!mcq!scq!tcq!ucq!ycq!zcq!{cq!|cq!}cq#Ocq#Pcq#Qcq#Rcq#Scq#Ucq#Vcq#Wcq#Xcq#Ycq#Zcq#[cq#]cq#^cq#_cq#`cq#acq#bcq#ccq#dcq#ecq#fcq#gcq#hcq#icq#jcq#kcq#mcq#ncq~OUqOwTOps!Zus!Zvs!Z~P7SOZ#sO~OZ#tO~Orw!T!U#U#V#W!q#Q#R#S!pt~",
  goto: ")a#mPPPP#n#rP#x#xP$TPPPPPP$q#x#x#xP%P%V%w&U&[&b&h&n&t'XPPP'gPPPPPPPPP'kPPPPPPP'{(WPPPPPP'{'{'{'{'{P'{'{'{'{'{PPPPP(yPPPPPPP)TPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP)ZTPORQVPQZUcoVZ[pt!m#^#a#kboVZ[pt!m#^#a#kf!Obcdef!Q!R!S!T!X!yT!hmnboVZ[pt!m#^#a#kR#Z!jQRORXRQUP^YU[t!m#^#a#kQ[VQtZU!mru!oQ#^!nQ#a!pR#k#``pVZ[t!m#^#a#kR!kpQx_R!rxQ{`R!t{Q}aR!u}Q![iR#R![Q!`jR#T!`Q!ckQ!elS!fm#[W#U!c!e!f#XR#X!iQ!nrQ!puU#_!n!p#`R#`!oTQORQrVSuZ[Q!otX#]!m#^#a#kcgVZ[pt!m#^#a#kQ!PbQ!UcQ!VdQ!WeQ!YfQ!w!QQ!x!RQ!z!SQ!{!TQ#P!XR#d!yQ!^iS#S![!dR#h#VQ!^jR#S!`Q!imR!jn",
  nodeNames: "⚠ NodeEdgeText NodeText FlowchartDiagram DiagramName Orientation LineComment NodeId Node ( String ) [ ] { } | Link Keyword NodeEdge HyphenatedWord Number",
  maxTerm: 122,
  propSources: [flowchartHighlighting],
  skippedNodes: [0],
  repeatNodeCount: 10,
  tokenData: "!Gb_R!cOX%^XY){YZ,RZ[){[]%^]^,R^p%^pq){qr%^rs,yst-itu.auv/zvw7awx8Xxy8wyz9oz|%^|}:g}!O;_!O!PCr!P!Q%^!Q![Dj![!]Eh!]!^HY!^!_IQ!_!`!$Z!`!a!+m!a!c%^!c!}.a!}#O!,e#O#P%^#P#Q!-]#Q#R%^#R#S.a#S#T!.T#T#c.a#c#d!.s#d#l.a#l#m!6d#m#o.a#o#p!>T#p#q!>{#q#r!?s#r#s!@k#s$f%^$f$g){$g#BY.a#BY#BZ!CZ#BZ$IS.a$IS$I_!CZ$I_$I|.a$I|$I}!E{$I}$JO!E{$JO$JT.a$JT$JU!CZ$JU$KV.a$KV$KW!CZ$KW&FU.a&FU&FV!CZ&FV;'S.a;'S;=`/t<%l?HT.a?HT?HU!CZ?HUO.a^%gX!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^Y&ZV!^W!YQOw&Swx&px#S&S#S#T'X#T;'S&S;'S;=`'p<%lO&SW&uS!^WO#S&p#T;'S&p;'S;=`'R<%lO&pW'UP;=`<%l&pQ'^S!YQOw'Xx;'S'X;'S;=`'j<%lO'XQ'mP;=`<%l'XY'sP;=`<%l&S['}V!^W![SOr'vrs&ps#S'v#S#T(d#T;'S'v;'S;=`({<%lO'vS(iS![SOr(ds;'S(d;'S;=`(u<%lO(dS(xP;=`<%l(d[)OP;=`<%l'vU)YV![S!YQOr)Rrs'Xsw)Rwx(dx;'S)R;'S;=`)o<%lO)RU)rP;=`<%l)R^)xP;=`<%l%^_*Wm!^W![S!YQrPOX%^XY){YZ%^Z[){[p%^pq){qr%^rs&Ssw%^wx'vx#S%^#S#T)R#T$f%^$f$g){$g#BY%^#BY#BZ){#BZ$IS%^$IS$I_){$I_$JT%^$JT$JU){$JU$KV%^$KV$KW){$KW&FU%^&FU&FV){&FV;'S%^;'S;=`)u<%l?HT%^?HT?HU){?HUO%^_,^X!^W![S!YQwPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_-SV!ZT!^W!YQOw&Swx&px#S&S#S#T'X#T;'S&S;'S;=`'p<%lO&S_-tX!RP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_.lb!^W![S!YQtPOr%^rs&Sst%^tu.auw%^wx'vx!Q%^!Q![.a![!c%^!c!}.a!}#R%^#R#S.a#S#T)R#T#o.a#o$g%^$g;'S.a;'S;=`/t<%lO.a_/wP;=`<%l.a_0TZ!^W![S!YQOr%^rs&Ssu%^uv0vvw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_1RZUP!^W![S!YQOY0vYZ%^Zr0vrs1tsw0vwx4ox#S0v#S#T6_#T;'S0v;'S;=`7Z<%lO0vZ1}XUP!^W!YQOY1tYZ&SZw1twx2jx#S1t#S#T3u#T;'S1t;'S;=`4i<%lO1tX2qVUP!^WOY2jYZ&pZ#S2j#S#T3W#T;'S2j;'S;=`3o<%lO2jP3]SUPOY3WZ;'S3W;'S;=`3i<%lO3WP3lP;=`<%l3WX3rP;=`<%l2jR3|VUP!YQOY3uYZ'XZw3uwx3Wx;'S3u;'S;=`4c<%lO3uR4fP;=`<%l3uZ4lP;=`<%l1t]4xXUP!^W![SOY4oYZ'vZr4ors2js#S4o#S#T5e#T;'S4o;'S;=`6X<%lO4oT5lVUP![SOY5eYZ(dZr5ers3Ws;'S5e;'S;=`6R<%lO5eT6UP;=`<%l5e]6[P;=`<%l4oV6hXUP![S!YQOY6_YZ)RZr6_rs3usw6_wx5ex;'S6_;'S;=`7T<%lO6_V7WP;=`<%l6__7^P;=`<%l0v_7lX!OP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_8bV!XR!^W![SOr'vrs&ps#S'v#S#T(d#T;'S'v;'S;=`({<%lO'v_9SXXP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_9zXZP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_:rX!SP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_;j^!nP!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!O<f!O!PBS!P!`%^!`!aBz!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_<qa#kP!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!O=v!O!`%^!`!a?l!a#S%^#S#T)R#T#c%^#c#d@d#d#l%^#l#mA[#m;'S%^;'S;=`)u<%lO%^_>RZ!mP!^W![S!YQOr%^rs&Ssw%^wx'vx!`%^!`!a>t!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_?PX!lP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_?wX!kP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_@oX!yP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_AgX!{P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_B_X#[P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_CVX!rP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_C}X#TP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_DuZeP!^W![S!YQOr%^rs&Ssw%^wx'vx!Q%^!Q![Dj![#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_EsZ!QP!^W![S!YQOr%^rs&Ssw%^wx'vx![%^![!]Ff!]#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_FoZ!^W![S!YQOr%^rs&Ssw%^wx'vx![%^![!]Gb!]#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_GmX!PP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_HeX#nP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_IZ]!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!OJS!O!_%^!_!`! i!`#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_J][!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!OKR!O!PLw!P#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_K^Z#XP!^W![S!YQOr%^rs&Ssw%^wx'vx!`%^!`!aLP!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_L[X!}P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_MSZ#ZP!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!OMu!O#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_NOZ!^W![S!YQOr%^rs&Ssw%^wx'vx!`%^!`!aNq!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_N|X#PP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_! rZ!^W![S!YQOr%^rs&Ssw%^wx'vx!_%^!_!`!!e!`#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!!pZ#YP!^W![S!YQOr%^rs&Ssw%^wx'vx!`%^!`!a!#c!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!#nX#OP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!$f[!vP!^W![S!YQOr%^rs&Ssw%^wx'vx!_%^!_!`!%[!`!a!*u!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!%g`#mP!^W![S!YQOr%^rs&Ssw%^wx'vx!_%^!_!`!&i!`!a!(_!a#S%^#S#T)R#T#c%^#c#d!)V#d#l%^#l#m!)}#m;'S%^;'S;=`)u<%lO%^_!&tZ!uP!^W![S!YQOr%^rs&Ssw%^wx'vx!`%^!`!a!'g!a#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!'rX!tP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!(jX!sP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!)bX!zP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!*YX!|P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!+QX!xP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!+xX!dP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!,pX[P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!-hX]P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!.^V!]X![S!YQOr)Rrs'Xsw)Rwx(dx;'S)R;'S;=`)o<%lO)R_!/Qf!^W![S!YQ!pPtPOr%^rs&Sst%^tu!0fuw%^wx'vx}%^}!O!2R!O!Q%^!Q![.a![!_%^!_!`!4p!`!c%^!c!}!0f!}#R%^#R#S!0f#S#T)R#T#o!0f#o$g%^$g;'S!0f;'S;=`!1{<%lO!0f_!0sb!^W![S!YQ!TPtPOr%^rs&Sst%^tu!0fuw%^wx'vx!Q%^!Q![!0f![!c%^!c!}!0f!}#R%^#R#S!0f#S#T)R#T#o!0f#o$g%^$g;'S!0f;'S;=`!1{<%lO!0f_!2OP;=`<%l!0f_!2[[!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!O!3Q!O!P!3x!P#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!3]X!^W![S!YQ#QPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!4TX!^W![S!YQ#SPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!4yZ!^W![S!YQOr%^rs&Ssw%^wx'vx!_%^!_!`!5l!`#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!5wX!^W![S!YQ#RPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!6qf!^W![S!YQ!qPtPOr%^rs&Sst%^tu!8Vuw%^wx'vx}%^}!O!9r!O!Q%^!Q![.a![!_%^!_!`!<a!`!c%^!c!}!8V!}#R%^#R#S!8V#S#T)R#T#o!8V#o$g%^$g;'S!8V;'S;=`!9l<%lO!8V_!8db!^W![S!YQ!UPtPOr%^rs&Sst%^tu!8Vuw%^wx'vx!Q%^!Q![!8V![!c%^!c!}!8V!}#R%^#R#S!8V#S#T)R#T#o!8V#o$g%^$g;'S!8V;'S;=`!9l<%lO!8V_!9oP;=`<%l!8V_!9{[!^W![S!YQOr%^rs&Ssw%^wx'vx}%^}!O!:q!O!P!;i!P#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!:|X!^W![S!YQ#UPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!;tX!^W![S!YQ#WPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!<jZ!^W![S!YQOr%^rs&Ssw%^wx'vx!_%^!_!`!=]!`#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!=hX!^W![S!YQ#VPOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!>`X^P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!?WX`P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!@OX_P!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!@tZ!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T#r%^#r#s!Ag#s;'S%^;'S;=`)u<%lO%^_!ApZ!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T#r%^#r#s!Bc#s;'S%^;'S;=`)u<%lO%^_!BnX!jP!^W![S!YQOr%^rs&Ssw%^wx'vx#S%^#S#T)R#T;'S%^;'S;=`)u<%lO%^_!Chu!^W![S!YQrPtPOX%^XY){YZ%^Z[){[p%^pq){qr%^rs&Sst%^tu.auw%^wx'vx!Q%^!Q![.a![!c%^!c!}.a!}#R%^#R#S.a#S#T)R#T#o.a#o$f%^$f$g){$g#BY.a#BY#BZ!CZ#BZ$IS.a$IS$I_!CZ$I_$JT.a$JT$JU!CZ$JU$KV.a$KV$KW!CZ$KW&FU.a&FU&FV!CZ&FV;'S.a;'S;=`/t<%l?HT.a?HT?HU!CZ?HUO.a_!FYb!^W![S!YQwPtPOr%^rs&Sst%^tu.auw%^wx'vx!Q%^!Q![.a![!c%^!c!}.a!}#R%^#R#S.a#S#T)R#T#o.a#o$g%^$g;'S.a;'S;=`/t<%lO.a",
  tokenizers: [nodeEdgeText, nodeText, 0, 1, 2, 3],
  topRules: {"FlowchartDiagram":[0,3]},
  specialized: [{term: 36, get: value => spec_identifier[value] || -1}],
  tokenPrec: 2522
});

const mermaidLanguage = LRLanguage.define({
    name: 'mermaid',
    parser: parser$3.configure({
        wrap: parseMixed((node) => {
            if (node.name === 'MindmapDiagram')
                return { parser: parser$2 };
            if (node.name === 'PieDiagram')
                return { parser: parser$1 };
            if (node.name === 'FlowchartDiagram')
                return { parser: parser };
            return null;
        }),
    }),
});
const mindmapLanguage = LRLanguage.define({
    name: 'mindmap',
    parser: parser$2,
});
const pieLanguage = LRLanguage.define({
    name: 'pie',
    parser: parser$1,
});
const flowchartLanguage = LRLanguage.define({
    name: 'flowchart',
    parser: parser,
});

function mermaid() {
    return new LanguageSupport(mermaidLanguage);
}
function mindmap() {
    return new LanguageSupport(mindmapLanguage);
}
function pie() {
    return new LanguageSupport(pieLanguage);
}
function flowchart() {
    return new LanguageSupport(flowchartLanguage);
}

const mermaidLanguageDescription = LanguageDescription.of({
    name: 'mermaid',
    load: async () => {
        return mermaid();
    },
});
const mindmapLanguageDescription = LanguageDescription.of({
    name: 'mindmap',
    load: async () => {
        return mindmap();
    },
});
const pieLanguageDescription = LanguageDescription.of({
    name: 'pie',
    load: async () => {
        return pie();
    },
});
const flowchartLanguageDescription = LanguageDescription.of({
    name: 'flowchart',
    alias: ['graph'],
    load: async () => {
        return flowchart();
    },
});

export { flowchart, flowchartLanguage, flowchartLanguageDescription, flowchartTags, mermaid, mermaidLanguage, mermaidLanguageDescription, mermaidTags, mindmap, mindmapLanguage, mindmapLanguageDescription, mindmapTags, pie, pieLanguage, pieLanguageDescription, pieTags };
